import { useDerivedCohortInfoContext } from '../context/DerivedCohortInfoContext';
export function useIsHubSpotOnCreditsPilot() {
  const {
    isHubSpotOnCredits,
    loading
  } = useDerivedCohortInfoContext();
  return {
    isInPilot: isHubSpotOnCredits,
    loading
  };
}